import React from 'react';
import MainLayout from './MainLayout';
import { useSidebarConfig, UserAuth } from './SidebarConfig';

interface LayoutWrapperProps {
  children: React.ReactNode;
  userAuth: UserAuth;
}

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => {
  return (
    <MainLayout>
      {children}
    </MainLayout>
  );
};

export default LayoutWrapper; 